const subaruPublicationTypeIcons = {
  msom: '\ue902',
  wmb: '\ue901',
  csom: '\ue903',
  dom: '\ue904',
  eom: '\ue905',
  om: '\ue906',
  gsg: '\ue900'
}

export const SubaruPublicationTypeIcon = ({ name, color = 'inherit', size = 18, className = '', ...rest }) => (
  <span
    className={`subaru-icon ${className}`.trim()}
    style={{
      color,
      fontSize: size
    }}
    {...rest}
  >
    {subaruPublicationTypeIcons[name]}
  </span>
)

export default SubaruPublicationTypeIcon
